'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.openPage = openPage;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var OPEN = '@@Navi/openPage';

var naviUrl = function naviUrl(state) {
	var params = state.navi.params;
	if (params.filter) {
		params.filter = JSON.stringify(params.filter);
	}
	var s = _url2['default'].format({
		pathname: '/' + state.navi.page,
		query: params
	});
	return s;
};

var initialState = {
	page: 'firm',
	params: {}
};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {

		case OPEN:
			var navi = {
				page: action.page,
				params: action.params
			};
			return _extends({}, navi);

		default:
			return state;
	}
}

function openPage(page) {
	var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return {
		type: OPEN,
		page: page,
		params: params,
		url: naviUrl
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/navi.js
 ** module id = 1059
 ** module chunks = 2
 **/